import React, { useState } from "react";
import I18n from "i18n-js";

import Flag from "./Flag";
import FlagsTable from "./FlagsTable";

const stats = [
  ["message_volume"],
  ["absolute_value", "delta_wow"],
  ["historical_avg", "historical_diff_in_percent"],
  ["team_delta_wow", "team_historical_avg"],
  ["team_pair_avg", "sentiment"]
];

const HealthStats = ({ flag, flags }) => {

  const [metadata, setMetadata] = useState(null);

  const selectFlag = (flag) => {
    setMetadata(flag?.metadata);
  }

  return (
    <div className="health-stats">
      <Flag flag={flag} />
      <div className="stats">
        <div className="stat-card">
          {stats.map((row, index) => (
            <div key={index} className="row">
              {row.map(stat => metadata?.hasOwnProperty(stat) ? (
                <div key={stat} className="stat">
                  <span
                    className="title"
                    title={I18n.t(`insights.stats.metadata.${stat}.title`)}
                  >
                    {I18n.t(`insights.stats.metadata.${stat}.title`)}
                  </span>
                  <span className="value">
                    {stat === "sentiment"
                      ? I18n.t(`insights.stats.metadata.sentiment.${metadata[stat]}`)
                      : parseFloat(metadata[stat]).toFixed(2)
                    }
                  </span>
                </div>
              ) : null)}
            </div>
          ))}
        </div>
      </div>
      <FlagsTable data={flags} onFlagClick={selectFlag} />
    </div>
  );
}

export default HealthStats;